<template>
  <div class="dialog-mask simple-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div class="dialog-header">{{ 'Confirm' | lang }}</div>
      <div class="dialog-body">
        <i class="fa fa-fw fa-exclamation-triangle bigicon"></i>
        <p>{{ manifest['GreylistWarningMessage_' + language] || dictValue('GreylistWarning')}}</p>
        <div class="floating-label">
          <input v-model="date" placeholder=" " type="date" />
          <label>{{ 'EndOfSuspension' | lang }}</label>
        </div>
        <div class="floating-label">
          <select v-model="cause" v-bind:value="cause" placeholder=" " :class="{ invalid: !cause }">
            <option v-for="(opt, idx) in internalOpts" :key="idx" :value="opt">{{opt.Label}}</option>
          </select>
          <label>{{ 'Cause' | lang }}</label>
        </div>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(false)">{{ 'Cancel' | lang}}</button>
        <button @click="sweetClose({ cause, date })" :disabled="!cause || !date">{{ 'Confirm' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'
import moment from 'moment'

export default {
  name: 'GreylistDialog',
  mixins: [ dialogMixin ],
  data () {
    return {
      cause: null,
      date: null
    }
  },
  props: {
    causes: {
      type: Array,
      required: true
    }
  },
  computed: {
    internalOpts () {
      if (!this.causes || !this.causes.length) {
        return []
      }
      if (typeof this.causes[0] === 'string') {
        return this.causes.map(opt => {
          return { Label: opt }
        })
      }
      return this.causes
    }
  },
  mounted () {
    setTimeout(() => {
      /* let inputEl = this.$el.querySelector('input')
      if (inputEl) {
        inputEl.focus()
      } */
      this.date = moment().add(30, 'days').format('YYYY-MM-DD')
    }, 300)
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

.simple-dialog {
  .fa-check {
    color: var(--green);
  }

  .fa-close {
    color: var(--red);
  }

  .fa-exclamation-triangle {
    color: var(--orange);
  }

  .bigicon {
    font-size: 2.5rem;
    margin: 1rem auto 0;
    display: block;
  }
}

</style>
